<div class="reseller-modal-content fd-modal-content">
<h3 fxLayoutAlign="center">Editar registro</h3>
<form [formGroup]="formGroup">
    <div fxLayoutAlign="center">
        <div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="center" class="filter-container">
            <div >
                <fd-input [parentForm]="formGroup" [field]="fields.resellerCode"></fd-input>
            </div>
            <div >
                <fd-select (loadItemsFn)="loadInstitutions($event)" [parentForm]="formGroup" [field]="fields.institution"
                    (selectionChange)="selectedInstitution()">
                </fd-select>
            </div>
            <div >
                <fd-select (loadItemsFn)="loadServiceContracts($event, null)" [parentForm]="formGroup"
                    [field]="fields.serviceContract" (selectionChange)="loadChannelTypes(null, formGroup.value.institution)">
                </fd-select>
            </div>
            <div >
                <fd-select (loadItemsFn)="loadChannelTypes($event, null)" (selectionChange)="loadChannels()" [parentForm]="formGroup" [field]="fields.channelType" ></fd-select>
            </div>
            <div >
                <fd-select (loadItemsFn)="loadChannels($event, null)" (selectionChange)="loadSubChannels()" [parentForm]="formGroup" [field]="fields.channel" ></fd-select>
            </div>
            <div>
              <fd-select (loadItemsFn)="loadSubChannels($event)" [parentForm]="formGroup" [field]="fields.subChannel" ></fd-select>
          </div>

            <div mat-dialog-actions>
                <div class="value-edit-table__button-container">
                    <fd-button mat-button fdSecondaryLarge [content]="'Cancelar'" (trigger)="close()"> </fd-button>
                    <fd-button fdPrimaryLarge mat-flat-button [content]="'Salvar'" (trigger)="edit()">
                    </fd-button>
                </div>
            </div>
        </div>
    </div>
</form>
</div>
